import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import Cookies from "js-cookie";
import ClosedModal from "../components/ClosedModal";
import InvalidAccessModal from "../components/InvalidAccessModal";

// 페이지 애니메이션 변형 설정
const pageVariants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition: {
      type: "tween",
      ease: "easeOut",
      duration: 0.5,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.3,
    },
  },
};

const WelcomePage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [apartmentName, setApartmentName] = useState("");
  const [showClosedModal, setShowClosedModal] = useState(false);
  const [showInvalidAccessModal, setShowInvalidAccessModal] = useState(false);

  // 컴포넌트 마운트 시 모든 쿠키 초기화 및 아파트 코드 확인
  useEffect(() => {
    // apartmentCode를 제외한 모든 쿠키 삭제
    const allCookies = Cookies.get();
    Object.keys(allCookies).forEach((cookieName) => {
      if (cookieName !== "apartmentCode") {
        Cookies.remove(cookieName);
        Cookies.remove(cookieName, { path: "/" });
        Cookies.remove(cookieName, {
          path: "/",
          domain: window.location.hostname,
        });
      }
    });

    // 아파트 코드 파라미터 확인
    const apartmentCode = searchParams.get("apartmentCode");
    const apartmentCodeFromCookie = Cookies.get("apartmentCode");

    // URL 파라미터 또는 쿠키에서 아파트명 설정
    if (
      apartmentCode === "Richmond" ||
      apartmentCodeFromCookie === "Richmond"
    ) {
      setApartmentName("더 리치먼드 평창");
    } else if (
      apartmentCode === "Raycounty" ||
      apartmentCodeFromCookie === "Raycounty"
    ) {
      setApartmentName("레이카운티");
    } else if (
      apartmentCode === "Harringtonplace" ||
      apartmentCodeFromCookie === "Harringtonplace"
    ) {
      setApartmentName("해링턴플레이스GTX운정");
    } else if (
      apartmentCode === "Singilpark" ||
      apartmentCodeFromCookie === "Singilpark"
    ) {
      setApartmentName("신길파크자이");
    } else if (
      apartmentCode === "DMCArtForest" ||
      apartmentCodeFromCookie === "DMCArtForest"
    ) {
      setApartmentName("DMC아트포레자이");
    } else if (
      apartmentCode === "GodeokUrbanBridge" ||
      apartmentCodeFromCookie === "GodeokUrbanBridge"
    ) {
      setApartmentName("e편한세상 고덕 어반브릿지");
    } else if (
      apartmentCode === "GeomdanUrbanCenter" ||
      apartmentCodeFromCookie === "GeomdanUrbanCenter"
    ) {
      setApartmentName("e편한세상 검단어반센트로");
    } else if (
      apartmentCode === "GeumgangPenteriumSeaglo" ||
      apartmentCodeFromCookie === "GeumgangPenteriumSeaglo"
    ) {
      setApartmentName("금강펜테리움 더시글로");
    } else if (
      apartmentCode === "GeumgangPenteriumSeagloOffice" ||
      apartmentCodeFromCookie === "GeumgangPenteriumSeagloOffice"
    ) {
      setApartmentName("아라역 금강펜테리움 더 시글로 1차 오피스텔");
    } else if (
      apartmentCode === "GangbyeonStarhills" ||
      apartmentCodeFromCookie === "GangbyeonStarhills"
    ) {
      setApartmentName("덕소강변스타힐스");
    } else if (
      apartmentCode === "YangjuOkjeongLH" ||
      apartmentCodeFromCookie === "YangjuOkjeongLH"
    ) {
      setApartmentName("양주 옥정 LH엘리프");
    } else if (
      apartmentCode === "UlsanGwellCityXiComplex1" ||
      apartmentCodeFromCookie === "UlsanGwellCityXiComplex1"
    ) {
      setApartmentName("울산지웰시티자이 1단지");
    } else if (
      apartmentCode === "YeongheungForestPrugioParkBien" ||
      apartmentCodeFromCookie === "YeongheungForestPrugioParkBien"
    ) {
      setApartmentName("영흥숲푸르지오파크비엔");
    } else if (
      apartmentCode === "HillstateYonginGojinStationComplex1" ||
      apartmentCodeFromCookie === "HillstateYonginGojinStationComplex1"
    ) {
      setApartmentName("힐스테이트용인고진역1단지");
    } else if (
      apartmentCode === "HillstateYonginGojinStationComplex2" ||
      apartmentCodeFromCookie === "HillstateYonginGojinStationComplex2"
    ) {
      setApartmentName("힐스테이트용인고진역2단지");
    } else if (
      apartmentCode === "HillstateBongdamPrideCity" ||
      apartmentCodeFromCookie === "HillstateBongdamPrideCity"
    ) {
      setApartmentName("힐스테이트봉담프라이드시티");
    } else if (
      apartmentCode === "PyeongchonIrvineFirstTheSharp" ||
      apartmentCodeFromCookie === "PyeongchonIrvineFirstTheSharp"
    ) {
      setApartmentName("평촌어바인퍼스트더샵");
    } else if (
      apartmentCode === "NaepoNewTownMoaMiraedMegacity2nd" ||
      apartmentCodeFromCookie === "NaepoNewTownMoaMiraedMegacity2nd"
    ) {
      setApartmentName("내포신도시모아미래도메가시티2차");
    } else if (
      apartmentCode === "BucheonIllumiState" ||
      apartmentCodeFromCookie === "BucheonIllumiState"
    ) {
      setApartmentName("부천일루미스테이트");
    } else if (
      apartmentCode === "SongdoStationSeohaeGrandbleThePark" ||
      apartmentCodeFromCookie === "SongdoStationSeohaeGrandbleThePark"
    ) {
      setApartmentName("송도역서해그랑블더파크");
    } else if (
      apartmentCode === "BupyeongHowstoryUrbanGreen" ||
      apartmentCodeFromCookie === "BupyeongHowstoryUrbanGreen"
    ) {
      setApartmentName("부평하우스토리어반그린");
    } else if (
      apartmentCode === "ForeonStation5" ||
      apartmentCodeFromCookie === "ForeonStation5"
    ) {
      setApartmentName("포레온스테이션5");
    } else if (
      apartmentCode === "테스트" ||
      apartmentCodeFromCookie === "테스트"
    ) {
      setApartmentName("테스트");
    } else {
      // 유효한 apartmentCode가 없으면 잘못된 접근으로 처리
      setApartmentName("");
      setShowInvalidAccessModal(true);
    }

    // 아파트 코드를 쿠키에 저장 (파라미터가 있을 때만)
    if (apartmentCode) {
      Cookies.set("apartmentCode", apartmentCode, { expires: 7 }); // 7일간 유효
    }
  }, [searchParams]);

  const handleSubmitAgreement = () => {
    // 접수 가능: 테스트, 덕소강변스타힐스, 울산지웰시티자이, 양주옥정LH엘리프, 평촌어바인퍼스트더샵, 내포신도시모아미래도메가시티2차, 부천일루미스테이트, 송도역서해그랑블더파크, 부평하우스토리어반그린
    const apartmentCode = searchParams.get("apartmentCode");
    const apartmentCodeFromCookie = Cookies.get("apartmentCode");
    const resolvedCode = apartmentCode || apartmentCodeFromCookie || "";

    if (!resolvedCode) {
      setShowInvalidAccessModal(true);
      return;
    }

    if (
      resolvedCode === "테스트" ||
      resolvedCode === "GangbyeonStarhills" ||
      resolvedCode === "UlsanGwellCityXiComplex1" ||
      resolvedCode === "YangjuOkjeongLH" ||
      resolvedCode === "PyeongchonIrvineFirstTheSharp" ||
      resolvedCode === "NaepoNewTownMoaMiraedMegacity2nd" ||
      resolvedCode === "BucheonIllumiState" ||
      resolvedCode === "SongdoStationSeohaeGrandbleThePark"
    ) {
      navigate("/kakao-login");
    } else {
      setShowClosedModal(true);
    }
  };

  const handleCheckSubmission = () => {
    // 카카오 소셜 로그인 URL 생성
    // const kakaoAuthUrl = `https://kauth.kakao.com/oauth/authorize?client_id=773567d2c88e5caba57b5acb024de423&redirect_uri=${encodeURIComponent(
    //   "http://localhost:3000/submission-result",
    // const kakaoAuthUrl = `https://kauth.kakao.com/oauth/authorize?client_id=773567d2c88e5caba57b5acb024de423&redirect_uri=${encodeURIComponent(
    //   "http://172.30.1.33:3000/submission-result",
    const kakaoAuthUrl = `https://kauth.kakao.com/oauth/authorize?client_id=773567d2c88e5caba57b5acb024de423&redirect_uri=${encodeURIComponent(
      "https://www.theh-agreement.co.kr/submission-result",
    )}&response_type=code&state=submission_check`;

    // 카카오 로그인 페이지로 이동
    window.location.href = kakaoAuthUrl;
  };

  const handleCloseModal = () => {
    setShowClosedModal(false);
  };

  return (
    <motion.div
      className="welcome-page"
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      style={{
        height: "100vh",
        background:
          "linear-gradient(180deg, #FFFFFF 0%, #EDEFF9 48%, #DADBF6 100%)",
        display: "flex",
        flexDirection: "column",
        padding: "40px 24px 24px 24px",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: "hidden",
      }}
    >
      {/* 메인 콘텐츠 영역 */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          textAlign: "left",
          paddingTop: "80px",
          paddingBottom: "200px",
        }}
      >
        {/* 웰컴 메시지 */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
          style={{ marginBottom: "16px" }}
        >
          <h1
            style={{
              fontSize: "18px",
              fontWeight: "400",
              color: "#333333",
              margin: "0 0 8px 0",
              lineHeight: "1.4",
            }}
          >
            안녕하세요,
          </h1>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "700",
              color: "#333333",
              margin: "0",
              lineHeight: "1.3",
            }}
          >
            {apartmentName}
            {apartmentName === "포레온스테이션5" ? "" : "아파트"}
            <br />
            {apartmentName === "포레온스테이션5"
              ? "소유주 여러분"
              : "입주민 여러분"}
          </h2>
        </motion.div>

        {/* 정보 텍스트 */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.5 }}
          style={{ marginBottom: "24px" }}
        >
          <p
            style={{
              fontSize: "16px",
              fontWeight: "400",
              color: "#666666",
              margin: "0",
              lineHeight: "1.5",
            }}
          >
            채권양도·양수 증서를 비대면으로 간편하게!
          </p>
        </motion.div>

        {/* 회사 로고 및 이름 */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.5 }}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          {/* 로고 */}
          <img
            src="/thehLogo.png"
            alt="법무법인 더 에이치 황해 로고"
            style={{
              width: "180px",
              height: "auto",
              objectFit: "contain",
            }}
          />
        </motion.div>
      </div>

      {/* 하단 버튼 영역 */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.5 }}
        style={{
          position: "fixed",
          bottom: "23px",
          left: "0",
          right: "0",
          padding: "20px 24px 40px",
          zIndex: 100,
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          paddingBottom: "env(safe-area-inset-bottom, 40px)",
        }}
      >
        {/* 채권양도·양수 동의서 접수하기 버튼 */}
        <button
          onClick={handleSubmitAgreement}
          style={{
            width: "100%",
            height: "56px",
            backgroundColor: "#7B42F6",
            color: "#FFFFFF",
            border: "none",
            borderRadius: "12px",
            fontSize: "16px",
            fontWeight: "600",
            cursor: "pointer",
            transition: "background-color 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#6A35E5";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "#7B42F6";
          }}
        >
          채권양도·양수 동의서 접수하기
        </button>

        {/* GodeokUrbanBridge일 때만 표시되는 버튼 */}
        {(searchParams.get("apartmentCode") === "GodeokUrbanBridge" ||
          Cookies.get("apartmentCode") === "GodeokUrbanBridge") && (
          <button
            onClick={() => {
              window.open(
                "https://defect-litigation-yemige.vercel.app/v1",
                "_blank",
              );
            }}
            style={{
              width: "100%",
              height: "56px",
              backgroundColor: "#FFFFFF",
              color: "#7B42F6",
              border: "2px solid #7B42F6",
              borderRadius: "12px",
              fontSize: "16px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "background-color 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#F5F3FF";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#FFFFFF";
            }}
          >
            하자조사 진행하기
          </button>
        )}

        {/* 접수내역 확인하기 버튼 */}
        <button
          onClick={handleCheckSubmission}
          style={{
            width: "100%",
            height: "56px",
            backgroundColor: "#FEE500",
            color: "#000000",
            border: "none",
            borderRadius: "12px",
            fontSize: "16px",
            fontWeight: "600",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            transition: "background-color 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#FDD835";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "#FEE500";
          }}
        >
          {/* 카카오 로고 이미지 */}
          <img
            src="/kakaoLogo.png"
            alt="카카오 로고"
            style={{
              width: "24px",
              height: "24px",
              objectFit: "contain",
            }}
          />
          접수내역 확인
        </button>
      </motion.div>

      {/* 잘못된 접근 안내 모달 */}
      <InvalidAccessModal isOpen={showInvalidAccessModal} />

      {/* 접수 마감 안내 모달 */}
      <ClosedModal
        isOpen={showClosedModal}
        onClose={handleCloseModal}
        apartmentName={apartmentName}
        isOpeningSoon={false}
        closedDate={
          apartmentName === "e편한세상 고덕 어반브릿지"
            ? "1월 21일"
            : apartmentName === "e편한세상 검단어반센트로"
              ? "1월 22일"
              : apartmentName === "아라역 금강펜테리움 더 시글로 1차 오피스텔"
                ? "1월 21일"
                : apartmentName === "금강펜테리움 더시글로"
                  ? "1월 21일"
                  : apartmentName === "더 리치먼드 평창"
                    ? "10월 10일"
                    : apartmentName === "레이카운티"
                      ? "10월 30일"
                      : apartmentName === "DMC아트포레자이"
                        ? "11월 11일"
                        : apartmentName === "해링턴플레이스GTX운정"
                          ? "12월 8일"
                          : apartmentName === "신길파크자이"
                            ? "12월 8일"
                            : apartmentName === "양주 옥정 LH엘리프"
                              ? "3월 19일"
                              : apartmentName === "영흥숲푸르지오파크비엔"
                                ? "3월 20일"
                                : apartmentName === "힐스테이트봉담프라이드시티"
                                  ? "8월 10일"
                                  : apartmentName === "힐스테이트용인고진역1단지"
                                    ? "9월 11일"
                                    : apartmentName === "힐스테이트용인고진역2단지"
                                      ? "9월 11일"
                                      : apartmentName === "포레온스테이션5" ||
                                          apartmentName ===
                                            "부평하우스토리어반그린"
                                        ? "11월 4일"
                                        : "9월 1일"
        }
      />
    </motion.div>
  );
};

export default WelcomePage;
